/* eslint-disable react/jsx-props-no-spreading */
import { memo, forwardRef, Suspense } from 'react';

import { lazyWithRetry } from 'services/lazy-load-components';

import { IconPlaceholder, IconErrorBoundary } from './IconErrorBoundary';
import type { Props } from './interfaces';

const LoadedIcon = lazyWithRetry(() => import('./LazyIcon'));

export const Icon = memo(
  forwardRef((props: Props, ref: JSX.IntrinsicElements['div']['ref']) => (
    <IconErrorBoundary width={props.width} height={props.height} inline={props.inline}>
      <Suspense fallback={<IconPlaceholder width={props.width} height={props.height} inline={props.inline} />}>
        <LoadedIcon {...props} ref={ref} />
      </Suspense>
    </IconErrorBoundary>
  ))
);
